class SolisGalleryWallCollection extends HTMLElement {
  connectedCallback() {
    this.filters = [...this.querySelectorAll('[data-gallery-filter]')];
    this.cards = [...this.querySelectorAll('[data-gallery-card]')];
    this.proofs = [...this.querySelectorAll('[data-gallery-proof]')];
    this.count = this.querySelector('[data-gallery-count]');

    this.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-gallery-filter]');
      if (filter) this.applyFilter(filter);

      const open = event.target.closest('[data-gallery-open]');
      if (open) this.openDialog(open.dataset.galleryOpen);

      const close = event.target.closest('[data-gallery-close]');
      if (close) close.closest('dialog')?.close();
    });

    this.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  applyFilter(button) {
    const value = button.dataset.galleryFilter;
    let visible = 0;

    this.filters.forEach((filter) => {
      const active = filter === button;
      filter.classList.toggle('is-active', active);
      filter.setAttribute('aria-pressed', String(active));
    });

    this.cards.forEach((card) => {
      const show = value === 'All' || card.dataset.galleryCategory === value;
      card.hidden = !show;
      if (show) visible += 1;
    });

    this.proofs.forEach((proof) => {
      proof.hidden = value !== 'All';
    });

    if (this.count) this.count.textContent = String(visible);
  }

  openDialog(id) {
    const dialog = this.querySelector(`#GalleryWallDialog-${CSS.escape(id)}`);
    if (dialog?.showModal) dialog.showModal();
  }
}

if (!customElements.get('solis-gallery-wall-collection')) {
  customElements.define('solis-gallery-wall-collection', SolisGalleryWallCollection);
}
